import React, { useState } from 'react';
import { jiraBrowseUrl, copyJiraLink } from '../utils/jiraLinks';

interface TicketKeyActionsProps {
  ticketKey: string;
  jiraUrl?: string | null;
  className?: string;
  /** Extra classes for the key link text */
  keyClassName?: string;
  stopPropagation?: boolean;
}

const TicketKeyActions: React.FC<TicketKeyActionsProps> = ({
  ticketKey,
  jiraUrl,
  className = '',
  keyClassName = 'font-mono text-sm font-extrabold text-complic-700 dark:text-complic-300 whitespace-nowrap',
  stopPropagation = true,
}) => {
  const [copied, setCopied] = useState(false);
  const browseUrl = jiraBrowseUrl(jiraUrl, ticketKey);

  const handleCopy = async (e: React.MouseEvent) => {
    if (stopPropagation) e.stopPropagation();
    e.preventDefault();
    const ok = await copyJiraLink(jiraUrl, ticketKey);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  const handleOpen = (e: React.MouseEvent) => {
    if (stopPropagation) e.stopPropagation();
    if (!browseUrl) {
      e.preventDefault();
    }
  };

  return (
    <span className={`inline-flex items-center gap-1 shrink-0 ${className}`}>
      {browseUrl ? (
        <a
          href={browseUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleOpen}
          className={`${keyClassName} hover:underline`}
          title={`Otevřít ${ticketKey} v Jiře`}
        >
          {ticketKey}
        </a>
      ) : (
        <span className={keyClassName} title={ticketKey}>
          {ticketKey}
        </span>
      )}
      {browseUrl && (
        <button
          type="button"
          onClick={handleCopy}
          className="p-0.5 rounded text-slate-400 hover:text-complic-600 dark:hover:text-complic-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition"
          title={copied ? 'Zkopírováno!' : 'Kopírovat odkaz do Jiry'}
          aria-label="Kopírovat odkaz do Jiry"
        >
          {copied ? (
            <svg className="w-3.5 h-3.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          )}
        </button>
      )}
    </span>
  );
};

export default TicketKeyActions;
